/*eslint-disable*/
import { Type } from 'app/constants/TourPoints';
import { getCustomId } from 'app/libs/core/Unique';
import mapUtils from '../../Utils/mapUtils';
import { placeAPI } from 'app/API/place.service.api';

export const getEmptyPoint = (type) => {
  const emptyPoints = {
    [Type.START]: {
      id: getCustomId(),
      type,
      title: '',
      isEmpty: true,
      unique_id: getCustomId() + getCustomId(),
    },
    [Type.VIA]: {
      id: getCustomId(),
      type,
      title: '',
      isEmpty: true,
      unique_id: getCustomId() + getCustomId(),
    },
    [Type.END]: {
      id: getCustomId(),
      type,
      title: '',
      isEmpty: true,
      unique_id: getCustomId() + getCustomId(),
    },
  };

  let point = emptyPoints[Type.START];
  switch (type) {
    case Type.VIA:
      point = emptyPoints[Type.VIA];
      break;
    case Type.END:
      point = emptyPoints[Type.END];
      break;
  }

  return tourPoint(point);
};

// export const tourPoint = point => {
export const tourPoint = ({
  lat,
  lng,
  id = getCustomId(),
  type,
  iconType,
  title,
  address,
  description,
  number,
  part,
  encodedpath,
  partId,
  images = [],
  imgids,
  draggable,
  isEmpty,
  distance,
  duration,
  isNotStickedToRoad,
  realCountry = '',
  canBeLast,
  correctLat,
  correctLng,
  keppCurrentCoord,
  wrongDist,
  unique_id,
  place_id,
  place_type,
  roadName = '',
}) => {
  const point = {
    id,
    lat,
    lng,
    type,
    iconType,
    title,
    address,
    description,
    number,
    part,
    encodedpath,
    partId,
    images,
    imgids,
    draggable,
    isEmpty,
    distance,
    duration,
    isNotStickedToRoad,
    realCountry,
    canBeLast,
    correctLat,
    correctLng,
    keppCurrentCoord,
    wrongDist,
    unique_id,
    isAutocorrection: false,
    roadName,
    place_id,
    place_type,
  };

  (point.__prevPointId = 0), (point.__nextPointId = 0);

  function getPrevId() {
    return point.__prevPointId;
  }
  function setPrevId(id) {
    point.__prevPointId = id;
  }

  function getNextId() {
    return point.__nextPointId;
  }
  function setNextId(id) {
    point.__nextPointId = id;
  }

  function isStart() {
    return this.type === Type.START;
  }
  function isEnd() {
    return this.type === Type.END;
  }
  function getType() {
    return this.type;
  }
  function setType(type) {
    this.type = type;
    if (type === Type.START) {
      this.encodedpath = '';
      this.distance = 0;
      this.duration = 0;
      this.correctLat = 0;
      this.correctLng = 0;
      this.number = 0;
      this.prevCoordStr = '';
    }
  }

  if (!point.id) point.id = getCustomId();

  if (!point.unique_id) {
    point.unique_id = point.id;
    // point.unique_id = point.id+getCustomId();
  }

  // if( !point.address && !point.isEmpty ){
  //     point.address = "Point address is loading...";
  // }

  function getId() {
    return point.id;
  }

  function isCoordsValid() {
    // console.log( this.type, this.id, this.prevCoordStr, /-?(\w+\.\w+|\w+)\,-?(\w+\.\w+|\w+)/.test(this.prevCoordStr));
    return (
      typeof this.lat !== 'undefined' &&
      typeof this.lng !== 'undefined' &&
      this.prevCoordStr &&
      /-?(\w+\.\w+|\w+)\,-?(\w+\.\w+|\w+)/.test(this.prevCoordStr)
    );
  }
  function getLatLng() {
    return { lat: this.lat, lng: this.lng };
  }
  function getCorrectCoord() {
    return {
      correctLat: this.correctLat,
      correctLng: this.correctLng,
      keppCurrentCoord: this.keppCurrentCoord,
    };
  }
  function isWrongCoord() {
    if (
      ((typeof this.correctLat === 'number' &&
        typeof this.correctLng === 'number') ||
        (typeof this.correctLat === 'string' &&
          typeof this.correctLng === 'string')) &&
      !this.keppCurrentCoord
    ) {
      return true;
    }
    return false;
  }
  function setCorrectCoord({
    correctLat,
    correctLng,
    keppCurrentCoord = 0,
    wrongDist,
  }) {
    this.correctLat = correctLat;
    this.correctLng = correctLng;
    this.keppCurrentCoord = keppCurrentCoord;
    this.wrongDist = wrongDist;
  }
  function correctPointPosition(correctLat, correctLng) {
    this.lat = correctLat;
    this.lng = correctLng;
    this.keppCurrentCoord = 0;
    this.correctLat = null;
    this.correctLng = null;
  }
  function keepCurrentCoord(bool) {
    this.keppCurrentCoord = bool;
  }
  function getCoordStr() {
    return `${this.lng},${this.lat}`;
  }
  function getPrevCoordStr() {
    return this.prevCoordStr;
  }
  function setAutocorrection(bool) {
    this.isAutocorrection = bool;
  }
  function setPrevCoordStr(coord) {
    if (typeof coord === 'string') {
      this.prevCoordStr = coord; // need to check coord before saving
    } else {
      const { lat, lng } = coord;
      this.prevCoordStr = `${lng},${lat}`;
    }
  }
  function setPrevCoord(coord) {
    this.prevLatLng = coord;
  }
  function getPrevCoord() {
    return this.prevLatLng;
    // if( this.prevLatLng ){
    //     return `${this.prevLatLng.lat}-${this.prevLatLng.lng}`;
    // }else{
    //     return getCustomId(); // nevers the same
    // }
  }
  function getPlaceId() {
    return this.place_id;
  }
  function setPlaceId(id) {
    this.place_id = id;
  }
  function getPlaceType() {
    return this.place_type;
  }
  function setPlaceType(type) {
    this.place_type = type;
  }

  function getInfoFromPlace(updatePointsData) {
    placeAPI.getPlaceFullDataById(this.place_id).then((res) => {
      if (res.response) {
        const {
          title = '',
          description = '',
          images = [],
          imgids = '',
        } = res.response;
        this.title = title;
        this.description = description;
        updatePointsData();
      }
    });
  }

  function stickToRoad(callback) {
    this.isNotStickedToRoad = true;
    mapUtils.stickToRoad(
      {
        nearest: { lat: this.lat, lng: this.lng },
      },
      (e) => {
        if (typeof e.mapped_coordinate !== 'undefined') {
          this.lat = e.mapped_coordinate[0];
          this.lng = e.mapped_coordinate[1];
          this.isNotStickedToRoad = false;
          this.roadName = e.roadName;
          callback(this);
        } else {
          console.error(e);
          // self.getMarker();
        }
      }
    );
  }
  function refreshAddress(updatePointsData, updateLatestPointHistory) {
    // this.address = "Point address is loading...";
    // updatePointsData();
    mapUtils.getTourstartGeocoder(
      { id: this.id, lat: this.lat, lng: this.lng },
      (e) => {
        const address = mapUtils.formateTourstartAddress(e.data);
        if (this.title === this.address) {
          this.title = address;
        }
        this.address = address;
        this.realCountry = mapUtils.getTourstartCountryCode(e.data);

        updatePointsData();
        updateLatestPointHistory(this, e.data);
      }
    );
  }

  return {
    ...point,
    stickToRoad,
    refreshAddress,
    getId,
    getPrevId,
    setPrevId,
    getNextId,
    setNextId,
    getType,
    setType,
    getLatLng,
    isCoordsValid,
    getCoordStr,
    getPrevCoordStr,
    setPrevCoordStr,
    setPrevCoord,
    getPrevCoord,
    isStart,
    isEnd,
    getCorrectCoord,
    setCorrectCoord,
    keepCurrentCoord,
    isWrongCoord,
    correctPointPosition,
    setAutocorrection,
    getPlaceId,
    setPlaceId,
    getPlaceType,
    setPlaceType,
    getInfoFromPlace,
  };
};
